<template>
  <v-container fluid>
       <v-card>
            <v-card-title>
               <h3>Acompanhamento dos contratos</h3>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
                <v-row>
                    <v-col :cols="dynamicCol">
                        <v-text-field v-model="search" prepend-icon="mdi-feature-search-outline" label="Pesquisar" clearable></v-text-field>
                    </v-col>
                  <v-col :cols="dynamicCol">
                    <v-select
                        :items="Sebraetec"
                        v-model="sebraetecSelecionado"
                        item-text="status"
                        item-value="id"
                        label="Sebraetec"
                        @change="[getTermos($event)]"
                        hide-details
                        outlined
                        dense
                        clearable
                    ></v-select>
                  </v-col>
                    <v-col :cols="dynamicCol">
                      <v-autocomplete
                          :items="tiposStatus"
                          v-model="statusSelecionado"
                          item-text="Descricao"
                          item-value="IdSituacao"
                          label="Filtrar por status"
                          @change="getTermos($event)"
                          hide-details
                          outlined
                          dense
                          clearable
                      ></v-autocomplete>
                    </v-col>
<!--                  Unidade                 -->
                  <v-col :cols="dynamicCol">
                    <v-autocomplete
                        :items="unidadesList"
                        v-model="unidadeSelecionada"
                        item-text="Unidade"
                        item-value="IdUnidade"
                        label="Unidade"
                        @change="[getTermos($event)]"
                        hide-details
                        outlined
                        dense
                        clearable
                    ></v-autocomplete>
                  </v-col>
                    <v-col :cols="dynamicCol">
                      <v-select
                          :items="Dias"
                          v-model="DiaSelecionado"
                          item-text="Status"
                          item-value="idDias"
                          label="Filtrar por dias a vencer"
                          @change="getTermos($event)"
                          hide-details
                          outlined
                          dense
                          clearable
                      ></v-select>
                    </v-col>
                    <v-col cols="2" v-if="sebraetecSelecionado!=null || statusSelecionado != null || DiaSelecionado != null || unidadeSelecionada != null">
                      <v-btn color="primary" width="100%" v-bind:id="dynamicCol" @click="[dynamicCol=2.4, limparFiltros()]"
                             dark>
                          Limpar Filtros
                      </v-btn>
                    </v-col>
                </v-row>
                <v-data-table
                    :items="termos"
                    :headers="headers"
                    :search="search"
                    :loading="loadTermos"
                    :expanded.sync="expanded"
                    show-expand
                    single-expand
                    item-key="IdContrato"
                    loading-text="Carregando..."
                    class="elevation-1"
                    >
                    <template v-slot:[`item.TipoContrato`]=" { item } ">
                        {{`${tipoContrato(item.TipoContrato)}`}}
                    </template>

                    <template v-slot:[`item.Descricao`] = "{item}">
                      <div>
                        <div class="pt-1 pb-1">
                          <v-chip v-if="item.Status == 'Autorizado - Ativo'" class="green" dark>{{item.situacao.Descricao}}</v-chip>
                          <v-chip v-else-if="item.Status == 'Aguardando autorização'" color="primary" dark>{{item.situacao.Descricao}}</v-chip>
                          <v-chip v-else-if="item.Status == 'Cancelado'" class="red" dark>{{item.situacao.Descricao}}</v-chip>
                          <v-chip v-else-if="item.Status == 'Encerrado'" class="purple" dark>{{item.situacao.Descricao}}</v-chip>
                          <v-chip v-else class="orange" dark>{{item.situacao.Descricao}}</v-chip>
                        </div>
                        <div class="pb-1">
                          <v-chip v-if="item.Sebraetec !== 0" class="primary white--text" > Sebraetec </v-chip>
                        </div>
                        <div class="pb-1">
                          <v-chip v-if="item.Parcelas == 1" color="grey" dark>{{`${item.Parcelas}`}} Parcela </v-chip>
                          <v-chip v-else color="grey" dark>{{`${item.Parcelas}`}} Parcelas</v-chip>
                        </div>
                      </div>
                    </template>
                    <template v-slot:[`item.VigenciaInicio`]=" { item } ">
                        {{`${$moment(item.VigenciaInicio).format('L')} à
                        ${$moment(item.VigenciaFim).format('L')}`}}
                    </template>
                    <template v-slot:[`item.Parcelas`]=" { item } ">
                        {{`${item.Parcelas}x`}}
                    </template>
                    <template v-slot:[`item.actions`]=" { item } ">
                        <v-btn icon>
                          <v-menu>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                  v-bind="attrs"
                                  v-on="on"
                                  icon
                              >
                                <v-icon>mdi-format-list-bulleted-square</v-icon>
                              </v-btn>
                            </template>
                            <v-list>
                              <v-list-item @click="[sendModalOcorrencia(item, 'registrar')]">
                                <v-list-item-title>
                                  Registrar ocorrência
                                </v-list-item-title>
                              </v-list-item>
                              <v-list-item @click="[sendModalOcorrencia(item, 'visualizar')]">
                                <v-list-item-title>
                                  Visualizar linha do tempo
                                </v-list-item-title>
                              </v-list-item>
                            </v-list>
                          </v-menu>
                        </v-btn>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on"  @click="[termoDetalhesCabecalho = [], getTermoDetalhes(item), modalTermoDetalhes = true]" icon>
                                    <v-icon>mdi-information</v-icon>
                                </v-btn>
                            </template>
                            <span>informações do contrato</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn v-bind="attrs" v-on="on" target="_blank" v-if="item.Path" :href="pathDocumento(item.Path)" icon>
                                    <v-icon>mdi-file-document</v-icon>
                                </v-btn>
                            </template>
                            <span>contrato</span>
                        </v-tooltip>
                        <!-- <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" v-if="item.IdSituacao!==3" @click="encerrarContrato(item)" icon>
                              <v-icon color="red">mdi-file-remove-outline</v-icon>
                            </v-btn>
                            <v-btn v-show="fixBug" disabled v-else icon>

                            </v-btn>
                          </template>
                          <span>encerrar contrato</span>
                        </v-tooltip> -->
                    </template>

                    <template v-slot:expanded-item="{ item }">
                      <td colspan="12" style="padding: 10px">
                        <v-data-table
                          :headers="headersAgendamento"
                          :items="item.agendamentos"
                          :loading="loading"
                          loading-text="Carregando..."
                          class="elevation-0"
                          hide-default-footer
                          disable-pagination
                        >
                            <template v-slot:[`item.dataInicial`]=" { item } ">
                              {{ $moment(item.dataInicial).format('L') }}
                            </template>

                            <template v-slot:[`item.cobrarTaxaDeslocamento`]="{ item }">
                                <v-chip v-if="item.cobrarTaxaDeslocamento == 0" class="red" dark> Não </v-chip>
                                <v-chip v-else class="green" dark> Sim </v-chip>
                            </template>
                        </v-data-table>
                      </td>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>
        <v-dialog width="80%" scrollable v-model="modalTermoDetalhes">
            <v-card>
                <v-card-title>
                    Detalhes do Contrato
                    <v-spacer></v-spacer>
                    <v-btn @click="[modalTermoDetalhes = !modalTermoDetalhes, termoDetalhes = []]" icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-list-item-title>
                    CNPJ: {{termoDetalhesCabecalho.CNPJ}}
                  </v-list-item-title>
                  <v-list-item-title>
                    Razão Social: {{termoDetalhesCabecalho.RazaoSocial}}
                  </v-list-item-title>
                  <v-list-item-title>
                    Contrato: {{termoDetalhesCabecalho.NumeroContrato}}
                  </v-list-item-title>
                  <v-list-item-title>
                    Período de vigência: {{`${$moment(termoDetalhesCabecalho.VigenciaInicio).format('L')}`}} à {{`${$moment(termoDetalhesCabecalho.VigenciaFim).format('L')}`}}
                  </v-list-item-title>
<!--                    <v-row>-->
<!--                        <v-col cols="6">-->
<!--                            <strong>{{termoDetalhesCabecalho.RazaoSocial}}</strong>-->
<!--                        </v-col>-->
<!--                        <v-col cols="6"></v-col>-->
<!--                    </v-row>-->

                    <!-- {{termoDetalhes}} -->
                    <v-data-table
                    :items="termoDetalhes"
                    :headers="headersDetalhes"
                    :search="searchDetalhes"
                    >
                    <template v-slot:[`item.ValorUnitario`]=" { item } ">
                        {{ item.ValorUnitario | numeral('$ 0,0.00') }}
                    </template>
                    <template v-slot:[`item.Percentual`]=" { item } ">
<!--                        {{  `${percentualRealizado(item.QuantidadeContratada, item.QuantidadeConsumida)}%` }}-->
                      <k-progress
                          status="success"
                          type="line"
                          :percent="item.Progresso  > 100 ? parseInt(item.Progresso = 100) : parseInt(item.Progresso)">
                        line-height="20px"
                      </k-progress>
                    </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </v-dialog>
    <AlertSystem :snackbar="system.snackbar"></AlertSystem>
    <OcorrenciasProcessoTermo :contrato="dadosOcorrencia" @atualiza-termos="getTermos()"></OcorrenciasProcessoTermo>
  </v-container>
</template>
<script>
import AlertSystem from "../components/AlertSystem.vue";
import OcorrenciasProcessoTermo from "../components/OcorrenciasProcessoTermo";
export default {
  name: 'TermosAcatamento',
  components: {
    AlertSystem,
    OcorrenciasProcessoTermo,
  },
  data: () => ({
    system:{
      snackbar: {
      },
    },
    fixBug: false,
    dadosOcorrencia: {
      IdContrato: null,
      Situacao: null,
      CNPJ: null,
      RazaoSocial: null,
      TipoContrato: null,
      VigenciaInicio: null,
      situacaoList: null,
      showDiagRegistrar: false,
      showDiagVisualizar: false,
      ocorrenciasList: null,
    },
    headers: [
        {text: "", value: "data-table-expand" },
        {text: "Razão social", value: "empresa.RazaoSocial"},
        {text: "CNPJ", value: "empresa.CNPJ"},
        {text: "Unidade", value: "unidade.Sigla"},
        {text: "Nº Contrato", value: "NumeroContrato"},
        {text: "Tipo de contrato", value: "TipoContrato"},
        {text: "Situação", value: "Descricao", width: '15%', align: 'center'},
        {text: "Vigência", value: "VigenciaInicio"},
        {text: "Ações", value: "actions", align: "right"}
    ],
    headersAgendamento: [
      { text: "Data do agendamento", value: "dataInicial"},
      { text: "Título", value: "titulo"},
      { text: "Observação interna", value: "obs_interna"},
      { text: "Taxa de deslocamento", value: "cobrarTaxaDeslocamento"},
    ],
    headersDetalhes: [
        {text: "Procedimento", value: "ServicoContratado"},
        {text: "Valor Unitário", value: "ValorUnitario"},
        {text: "Qtd. Contratada", value: "QuantidadeContratada"},
        {text: "Qtd. Consumida", value: "QuantidadeConsumida"},
        {text: "Percentual realizado", value: "Percentual"}
    ],
    termos: [],
    expanded: [],
    tiposStatus:[
      {
        IdSituacao:[],
        Descricao:[],
      }
    ],
    Sebraetec:[
      {
        id: 2,
        status: 'Não'
      },
      {
        id: 1,
        status: 'Sim'
      }
    ],
    sebraetecSelecionado: null,
    Dias:[
      {
        idDias: 30,
        Status: '30 Dias'
      },
      {
        idDias: 45,
        Status: '45 Dias'
      },
      {
        idDias: 60,
        Status: '60 Dias'
      },
      {
        idDias: 90,
        Status: '90 Dias'
      },
    ],
    termoDetalhesCabecalho: {
      CNPJ: null,
      RazaoSocial: null,
      NumeroContrato: null,
      VigenciaInicio: "",
      VigenciaFim: "",
    },
    dynamicCol: 2.4,
    termoDetalhes: [],
    unidadesList: [],
    statusSelecionado:null,
    DiaSelecionado: null,
    search: '',
    searchDetalhes: '',
    status: 1,
    loadTermos: false,
    loadTermoDetalhes: false,
    modalTermoDetalhes: false,
    agendamento: {},
    dataInicialFatura: '',
    dataFinalFatura: '',
    menuDataInicial: false,
    menuDataFinal: false,
    unidadeSelecionada: null,
    ocorrenciasList: [],
    situacaoList: [],
  }),
  methods: {
    getLinhaTempo(IdContrato){
      this.axios.get(`termos/${IdContrato}/linha`).then( res => {
        this.dadosOcorrencia.ocorrenciasList = res.data
      })
    },
    sendModalOcorrencia(item, dialog){
      this.dadosOcorrencia = {
        ...this.dadosOcorrencia,
        IdContrato: item.IdContrato,
        Situacao: item.Situacao,
        CNPJ: item.CNPJ,
        RazaoSocial: item.RazaoSocial,
        TipoContrato: item.TipoContrato,
        VigenciaInicio: item.VigenciaInicio,
        situacaoList: this.situacaoList
      }
      switch (dialog) {
        case 'registrar':
          this.dadosOcorrencia.showDiagRegistrar = true
          break
        case 'visualizar':
          this.getLinhaTempo(item.IdContrato)
          this.dadosOcorrencia.showDiagVisualizar = true
          break
        default:
          this.dadosOcorrencia.showDiagRegistrar = false
          this.dadosOcorrencia.showDiagVisualizar = false
          break
      }
    },
    getUnidades() {
      this.axios('unidades').then(res => {
        this.unidadesList = res.data
      })
    },
    getTermos () {
        this.loadTermos = true
        this.axios.get('/termos', {
          params:{
            IdSituacao: this.statusSelecionado,
            diasVencer: this.DiaSelecionado,
            IdUnidade: this.unidadeSelecionada,
            Sebraetec: this.sebraetecSelecionado,
          }
        }).then( res => {
            this.termos = res.data.map( elem => {
              elem.RazaoSocial = this.prepareNameFilter(elem.RazaoSocial);
                return {
                    ...elem,
                    Status: this.situacaoContrato(elem.VigenciaFim, elem.Situacao) //Dessa forma se consegue pesquisar pelo status
                }
            })
        }).finally(() => {
            this.loadTermos = false

        })
    },
    encerrarContrato (item) {
      let con = confirm('Você deseja encerrar esse contrato?')
      if (con) {
        this.axios.put(`/termos/${item.IdContrato}`).then((res) => {
          this.system.snackbar = {
            snackbar: true,
            text: res.data,
            color: "green",
          };
          this.getTermos()
        }).catch((e) => {
          this.system.snackbar = {
            snackbar: true,
            text: e.response.data,
            color: "red",
          };
        })
      }
    },
    getTermoDetalhes (item) {
      this.loadTermoDetalhes = true
        this.axios.get(`/termos/${item.IdContrato}/empresas/${item.IdEmpresa}`).then( res => {
            this.termoDetalhes = res.data
            this.termoDetalhesCabecalho.CNPJ = res.data[0].CNPJ
            this.termoDetalhesCabecalho.RazaoSocial = res.data[0].RazaoSocial
            this.termoDetalhesCabecalho.NumeroContrato = res.data[0].NumeroContrato
            this.termoDetalhesCabecalho.VigenciaFim = res.data[0].VigenciaFim
            this.termoDetalhesCabecalho.VigenciaInicio = res.data[0].VigenciaInicio
            this.termoDetalhes.map((elem) => {
            if(elem.QuantidadeConsumida > 0) {
              elem.Progresso = parseFloat(((elem.QuantidadeConsumida *100) / elem.QuantidadeContratada).toFixed(0))
            } else {
              elem.Progresso = 0
            }
          })
        }).finally(() => {
          this.loadTermoDetalhes = false
        })
    },
    tipoContrato(contratoTipo) {
      const tipos = [ 
        '',
        'Portal de Serviços',     // Índice 1
        'Termo de Acatamento',    // Índice 2
        'Outros',                 // Índice 3
        'Indústria Mais Segura'   // Índice 4
      ];

      return tipos[contratoTipo];
    },
    filtroStatus(event){
      this.statusSelecionado = event
      if (this.statusSelecionado == 'Todos'){
        this.statusSelecionado = ''
      }
    },
    situacaoContrato(VigenciaFim, Situacao) {
        const situacao = [
            'Aguardando autorização',
            'Autorizado',
            'Cancelado',
            'Encerrado',
            'Autorizado - Expirado',
            'Aguardando empresa'
        ]

        return situacao[Situacao]

    },
    // percentualRealizado (QuantidadeContratada, QuantidadeConsumida) {
    //     return parseInt((QuantidadeConsumida * 100) / QuantidadeContratada)
    // },
    pathDocumento (path) {
        if(path != null){
            return `https://sis.rn.sesi.org.br/gs/${path.substring(2, path.length)}`
        }else{
            return path
        }
    },
    limparFiltros(){
      this.statusSelecionado = null
      this.DiaSelecionado = null
      this.unidadeSelecionada = null
      this.sebraetecSelecionado = null
      this.search = null
      this.getTermos();
    },
    tipoStatus(){
      this.axios('termos/tipoStatus').then(res => {
        this.tiposStatus = res.data

      })
    },
    getContratoSituacao(){
      this.axios('termos/tipoStatus').then(res => {
        this.situacaoList = res.data
      })
    }
  },
  mounted() {
    this.getContratoSituacao()
    this.getTermos()
    this.getUnidades()
    this.tipoStatus()
  }
}
</script>

<style>
</style>
